import { BaseHomeSchema } from '@space-core/datahub/hotmartClub'

type ConstructorParams = {
  productId?: string
  studentDiscount?: string
  nonStudentDiscount?: string
  isStudent?: boolean
  isRedirectToProductDetails?: boolean
  isRedirectClubProductPage?: boolean
}

export class ClickHomeKnowProduct extends BaseHomeSchema {
  action: string
  productId: string
  studentDiscount: string
  nonStudentDiscount: string
  isStudent: boolean
  isRedirectToProductDetails: boolean
  isRedirectClubProductPage: boolean
  private pushKind: string

  constructor({
    productId = '',
    studentDiscount = '',
    nonStudentDiscount = '',
    isStudent = false,
    isRedirectToProductDetails = false,
    isRedirectClubProductPage = false
  }: ConstructorParams) {
    super()
    this.action = 'click_showcase_know'
    ;(this.pushKind = 'NOT_PUSH_EVENT'), (this.productId = productId)
    this.studentDiscount = studentDiscount
    this.nonStudentDiscount = nonStudentDiscount
    this.isStudent = isStudent
    this.isRedirectToProductDetails = isRedirectToProductDetails
    this.isRedirectClubProductPage = isRedirectClubProductPage
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      pushKind: this.pushKind,
      productId: this.productId,
      studentDiscount: this.studentDiscount,
      nonStudentDiscount: this.nonStudentDiscount,
      isStudent: this.isStudent,
      isRedirectToProductDetails: this.isRedirectToProductDetails,
      isRedirectClubProductPage: this.isRedirectClubProductPage
    }
  }
}
